// src/components/Header.jsx
import React, { useState } from 'react';
import '../App.css';
import logo from '../assets/images/doctor.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header" id="home">
      <div className="header-container">
        <div className="logo-text-wrapper">
          <img src={logo} alt="Dr. Srishti Dentistry" className="logo" />
          <div className="header-tagline">
            <h2>Dr. Srishti Dentistry & Wellness Clinic</h2>
                <p>Smile Brighter, Live Better</p>
          </div>
        </div>

        {/* Hamburger icon visible only on mobile */}
        <div className="hamburger" onClick={toggleMobileMenu}>
          <div className="bar" />
          <div className="bar" />
          <div className="bar" />
        </div>

        {/* Desktop Navigation */}
        <nav className="nav desktop-nav">
          <ul>
            <li><a href="hro-econtent">Home</a></li>
            <li><a href="#about-section">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#visit-us">Contact</a></li>
          </ul>
        </nav>
      </div>

      {/* Mobile Sidebar Navigation */}
      <nav className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="#Home" onClick={toggleMobileMenu}>Home</a></li>
          <li><a href="#about-section" onClick={toggleMobileMenu}>About</a></li>
          <li><a href="#services" onClick={toggleMobileMenu}>Services</a></li>
          <li><a href="#visit-us" onClick={toggleMobileMenu}>Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
